<template>
  <div id="classes">
    <div v-if="errored" class="empty px-8 pt-6">
      <p>
        We are not able to retrieve this information at the moment, please try
        back later
      </p>
    </div>

    <div id="content-area" v-else>
      <div
        style="width: 100%; text-align: center"
        class="spin-holder mt-4"
        v-if="loading"
      >
        <i class="spinner fa fa-spinner fa-spin"></i>
        <p>Loading Classes</p>
      </div>

      <div class="assessmentconfig w-11/12 ml-4 flex">
        <div class="bg-white w-full pb-3 mb-10">
          <div class="px-4">
            <!-- Section -->
            <section>
              <div
                class="flex flex-wrap -mx-3 mb-2"
                v-for="(row, index) in orderedList"
                :key="index"
              >
                <div class="w-7/12 px-3">
                  <input
                    :value="row.oldValue"
                    @input="row.newValue = $event.target.value"
                    class="appearance-none block w-full bg-gray-100 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                    id="grid-title"
                    type="text"
                    placeholder="Enter class name"
                    required=""
                  />
                </div>
                <div
                  class="w-1/12 py-4 text-center text-xs cursor-pointer text-blue-400 hover:opacity-50"
                >
                  <a @click="editClass(row)">Update</a>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { PupilService } from "@/services/pupil.service";

export default {
  name: "classes",
  computed: {
    ...mapGetters({ currentUser: "currentUser", access: "currentAccess" }),
    orderedList() {
      return this.classes.sort();
    },
  },
  watch: {},
  data() {
    return {
      errored: false,
      loading: false,
      classes: [],
    };
  },
  created() {
    this.loading = true;
    this.fetchClasses();
  },
  mounted() {},
  methods: {
    fetchClasses() {
      PupilService.getClasses()
        .then((response) => this.buildClassList(response.data.data))
        .catch((err) => {
          console.log("classes " + err);
          this.errored = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    buildClassList(data) {
      this.classes = data.map(function (item, index) {
        return { oldValue: item, newValue: "" };
      });
    },
    failure(error) {
      this.errored = true;
      console.log("Class update error " + error);
    },
    editClass(row) {
      if (row.newValue.length < 2) {
        this.alertDisplay("Class name must be at least 2 characters");
        return 
      } else {
        this.processClass(row);
      }
    },
    alertDisplay(msg) {
      this.$swal({
        title: "Empty Value",
        text: msg,
        type: "warning",
        showCancelButton: false,
        showCloseButton: true,
        showLoaderOnConfirm: true,
      });
    },
    processClass(row) {
      let payload = {
        inclass: row.newValue,
        old_inclass: row.oldValue,
      };

      let vm = this;
      PupilService.updateClass(payload)
        .catch((err) => {
          vm.failure(err);
        })
        .finally(() => {
          vm.fetchClasses();
        });
    }
  },
  components: {},
};
</script>


<style scoped>
.lean-right {
  text-align: right;
}
</style>

